import { attribute, clickable, isPresent, text } from 'ember-cli-page-object';
import ModalObj from 'core/test-support/pages/components/hds-modal';
export default (scope = '[data-test-modal-action]', properties = {}) => ({
  ...ModalObj,
  scope,
  isOpen: isPresent(),
  submitText: text('[data-test-submit]'),
  title: text('[data-test-title]'),
  submitDisabled: attribute('disabled', '[data-test-submit]'),
  submit: clickable('[data-test-submit]'),
  cancel: clickable('[data-test-cancel]'),
  ...properties
});